import { Component, Input } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";

import { TranslatePipe } from "../../common/translate";
import { NavigationService } from "../../common/navigation/navigation.service";

@Component({
	selector: "sdp-wizard-navigation",
	templateUrl: "./wizard-navigation.component.html"
})
export class WizardNavigationComponent {
	@Input()
	public nextPage = "/home";

	@Input()
	public previousPage = "";

	public showNext = true;

	constructor(
		router: Router,
		private translate: TranslatePipe,
		private navigationService: NavigationService,
	) {
		router.events.subscribe((event) => {
			if (event instanceof NavigationEnd) {
				this.setNext(router);
			}
		});
	}

	public setNext(router: Router) {
		this.showNext = router.routerState.snapshot.url.indexOf("access") < 0;
	}

	public navigateToPage(page: string) {
		if (page === "/administration") {
			this.navigationService.navigate(["administration"]);
		} else {
			this.navigationService.navigate([`wizard/${page}`]);
		}
	}

	public getNext() {
		return this.nextPage !== "/administration" ?
			this.translate.transform("sdp.label.next") :
			this.translate.transform("sdp.label.closeWizard");
	}
}
